import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AnnotationsStorageService } from '../../../annotations/core/annotations-storage.service';
import { EntityType } from '../../shared/shared/entity-type.enum';
import { Visibility } from '../../shared/shared/types/visibility.enum';
import { Comment } from '../comment';

@Component({
  selector: 'rl-edit-comment',
  templateUrl: './edit-comment.component.html',
  styleUrls: ['./edit-comment.component.scss', './edit-comment.component-rtl.css']
})
export class EditCommentComponent implements OnDestroy {

  constructor(private annStorage : AnnotationsStorageService) {
    this.annStorage.getVisibility().pipe(takeUntil(this.destroy$)).subscribe(visibility => {
      this.visibility = visibility;
      this.placeHolder += '.' + this.visibility;
    });
  }

  @Input('comment') set c(c : Comment){
    this.comment = {...c};
    if ((this.comment.entityType && (this.comment.entityType === EntityType.ASSIGNMENT || this.comment.entityType === EntityType.SUBMISSION))
      || (!this.comment.entityType && this.annStorage.getCommentById(this.comment.parentAttachedId)?.entityType === EntityType.SUBMISSION)) {
      this.placeHolder = 'comment.new.placeholder';
      this.savePublishButton = 'general.save';
    } else {
      this.savePublishButton = this.visibility === 'PRIVATE' ? 'general.save' : 'general.publish';
    }
  }
  @Input() visibilityAllowed : 'all' | 'private' | 'public' = 'public';
  @Output() onSave = new EventEmitter<Comment>();
  @Output() onCancel = new EventEmitter<void>();
  
  visibility: Visibility;
  placeHolder: string = 'comment.new.placeholder';
  errorMsg : string;
  comment : Comment;
  savePublishButton: string;
  private destroy$ = new Subject<void>();

  save(e : Comment){
    if(!this.comment.title){
      this.errorMsg = 'error.no.text.entered';
    } else {
      this.onSave.emit(e);
    }
  }

  cancel(){
    this.onCancel.emit();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
